export default "__VITE_ASSET___vgPbF0W__"